import * as React from 'react';
import { autorun } from 'mobx';

import { Tabs, Title } from '../../modules/modules';
import Products from './components/Products';
import AuthService from '../../services/AuthService';

interface IFeaturedState {
  loggedCustomer?: string;
}

class Featured extends React.Component<{}, IFeaturedState> {
  public componentDidMount() {
    autorun(() => this.setState({loggedCustomer: ((customer) => customer && customer.id || undefined)(AuthService.GetInstance().customer)}));
  }

  public render() {
    const tabs = {
      'top': {
        'tag': 'Top',
        'title': 'Top',
      },
      'bestdeal': {
        'tag': 'Best deal',
        'title': 'Best deal',
      }
    };

    return (
      <div className="featured">
        <div className="best-sellers">
          <Title type="thin">Best sellers</Title>
          <Products tag="Best sellers" limit={4} loggedCustomer={this.state && this.state.loggedCustomer || undefined}/>
        </div>
        
        <Title type="thin">Recommended products</Title>
        <Tabs
          type="white-background"
          tabs={
            Object.keys(tabs).map((tabKey: any) => tabs[tabKey].title)
          }
        >
          {Object.keys(tabs).map((tabKey: any) => {
            const tab = tabs[tabKey];
            return (
              <Products key={tabKey} tag={tab.tag} limit={12} />
            );
          })}
        </Tabs>
      </div>
    );
  }
}

export default Featured;



// WEBPACK FOOTER //
// ./src/components/Featured/Featured.tsx